const months = [
  { label: 'app.january', value: 1 },
  { label: 'app.february', value: 2 },
  { label: 'app.march', value: 3 },
  { label: 'app.april', value: 4 },
  { label: 'app.may', value: 5 },
  { label: 'app.june', value: 6 },
  { label: 'app.july', value: 7 },
  { label: 'app.august', value: 8 },
  { label: 'app.september', value: 9 },
  { label: 'app.october', value: 10 },
  { label: 'app.november', value: 11 },
  { label: 'app.december', value: 12 },
]

const days = [
  { label: 'app.monday', value: 1 },
  { label: 'app.tuesday', value: 2 },
  { label: 'app.wednesday', value: 3 },
  { label: 'app.thursday', value: 4 },
  { label: 'app.friday', value: 5 },
  { label: 'app.saturday', value: 6 },
  { label: 'app.sunday', value: 0 },
]

const monthDays = Array.from({ length: 31 }, (_, i) => ({ value: i + 1 }))

const monthWeeks = [
  { label: 'app.sequence.first', value: 1 },
  { label: 'app.sequence.second', value: 2 },
  { label: 'app.sequence.third', value: 3 },
  { label: 'app.sequence.fourth', value: 4 },
]

const calendarHelper = {
  days,
  months,
  monthDays,
  monthWeeks,
}

export default calendarHelper
